module.exports = __webpack_public_path__ + "img/detail-bg-img.02a45023.png";